module.exports = {
  footerText: 'Copyright ENARM © 2019',
}
